module.exports = __webpack_public_path__ + "static/media/schematic-upload.67082ebc.svg";